import { MitsIconModule } from '../mits-icon/mits-icon.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { MitsButtonsPopover } from './mits-buttons.popover';

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule, MitsIconModule],
  declarations: [MitsButtonsPopover],
  entryComponents: [MitsButtonsPopover],
  exports: [MitsButtonsPopover],
  providers: [],
})
export class MitsButtonsPopoverModule {}
